"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M26.4,83.7c0,0,16.8,16.8,39.8,10.5c26.3-7.2,37.7-32.3,29.1-53.2S61.3,11.8,37.6,19.1C19.6,24.7,5.6,39,0,55.7l0,0 C0,24.9,25.5,0,57.1,0s57.2,25,57.3,55.8c0,30.8-25.6,56.4-56.3,56.4c-16.3,0-29.6-10.3-31.6-28.2C26.4,83.7,26.4,83.7,26.4,83.7z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M88.2,61.2c0,0,2.6-10.6-3.6-19.9c-5.1-7.7-14.7-14.4-30.4-14.4c-37.5,0-51.6,35.4-52.6,46.2s-7,47,54.7,94.2 c0,0,53.9-35.8,56-80.2c0,0-14.8,38.3-56.5,36.5c-40.9-1.7-50.3-53.7-22.3-73C60.1,32.4,84,49.9,88.2,61.2z"
  })]
}), '0 0 114.4 167.3');